import { useCallback, useEffect, useState } from 'react';
import api from '../../lib/api';
import { Button } from '../ui/button';
import { ActionCard } from './ActionCard';
import { Inbox, Loader2 } from 'lucide-react';

const FILTERS = [['pending', 'Waiting'], ['approved', 'Approved'], ['rejected', 'Rejected'], ['expired', 'Expired'], ['all', 'All']];

export const ApprovalQueue = () => {
  const [status, setStatus] = useState('pending');
  const [rows, setRows] = useState(null);

  const load = useCallback(async () => {
    setRows(null);
    const { data } = await api.get('/duti/actions', { params: { status } });
    setRows(data.actions);
  }, [status]);

  useEffect(() => { load().catch(() => setRows([])); }, [load]);

  return (
    <section className="space-y-5" data-testid="duti-approval-queue">
      <div className="flex flex-wrap gap-2">
        {FILTERS.map(([k, l]) => (
          <Button key={k} size="sm" variant={status === k ? 'default' : 'outline'} className="rounded-full" onClick={() => setStatus(k)} data-testid={`duti-queue-filter-${k}`}>
            {l}
          </Button>
        ))}
      </div>
      {rows === null && <Loader2 className="h-5 w-5 animate-spin text-muted-foreground" />}
      {rows?.length === 0 && (
        <div className="rounded-xl border border-dashed p-10 text-center text-muted-foreground" data-testid="duti-queue-empty">
          <Inbox className="h-8 w-8 mx-auto mb-2 opacity-40" />
          Nothing here. Drafts Duti AI prepares will land in this queue for you to decide on.
        </div>
      )}
      <div className="grid gap-4 xl:grid-cols-2">
        {rows?.map((a) => <ActionCard key={a.action_id} action={a} decidable onDone={load} />)}
      </div>
    </section>
  );
};
